import React, {useCallback, useContext, useEffect, useState} from "react";

import { useFeatureValue } from "@hooks/use-feature-value";
import {CartContext} from "@contexts/Cart.jsx"
import {ProductCustomizerVariantContext} from "@contexts/ProductCustomizerVariant.jsx"
import ProductCustomizerItem from "./ProductCustomizerItem.jsx"

import { getRestIdFromGid } from "@utility/shopify"

export default ({ collection }) => {

  const { cart } = useContext(CartContext);
  const { loading: loading, variant, compatibilityKeys, focusedCollection, setFocusedCollection, toggleTrayOpen } = useContext(ProductCustomizerVariantContext);

  const trayTrigger = useFeatureValue("customizer-education-trigger");

  const [vehicleDataReady, setVehicleDataReady] = useState(!!window.__VPV?.vehicleJsonReady);

  useEffect(() => {
    if(vehicleDataReady) return;

    const onVehicleJsonReady = () => setVehicleDataReady(true);
    document.addEventListener("vehicleJsonReady", onVehicleJsonReady);
    return () => document.removeEventListener("vehicleJsonReady", onVehicleJsonReady);
  }, [vehicleDataReady]);

  const recomendationNodes = collection.products?.map((product, index) => {

    if(compatibilityKeys && compatibilityKeys.length > 0){
      product.variants = product.variants.filter((variant) => {

        if(variant.compatibilityKeys?.value){
          try{
            const variantCompatibilityKeys = JSON.parse(variant.compatibilityKeys.value);
            const compatible = variantCompatibilityKeys.find((key)=>{
              if(compatibilityKeys.indexOf(key) > -1){
                return true;
              }
            });
            return compatible;
          }catch(e){
            console.error(e);
            return true;
          }
        }else{
          return true;
        }
      });
      //console.log(product);
      if(product.additionalOptions?.references.length > 0){
        product.additionalOptions.references = filterReferencesByCompatibility(product.additionalOptions.references, compatibilityKeys);
      }

    }else{
      product.variants = [...product.variants]
    }

    if(product.usesVehiclePicker?.value == 'true'){
      if(!vehicleDataReady){
        return null;
      }

      const cartItem = cart?.items.find((item) => {
        return getRestIdFromGid(variant.id) == item.variant_id;
      });

      const contextVehicle = {
        make: cartItem?.properties?._vehicle_make,
        model: cartItem?.properties?._vehicle_model,
        year: cartItem?.properties?._vehicle_year,
      }
      
      const vehicles = VehicleData.getDataByVehicle(contextVehicle);
      const { filteredVariants, filteredVehicles } = filteredVariantsByVehicleData(product.variants, vehicles);
      product.variants = filteredVariants
      product.vehicles = filteredVehicles;
      
    }

    if(product.variants.length > 0){
      const variantIds = product.variants.map( (variant) => getRestIdFromGid(variant.id) );
      const item = cart?.items.find((item) => {
        return variantIds.indexOf(item.variant_id.toString()) > -1;
      });

      return <ProductCustomizerItem min={variant.product.id == product.id ? 1 : 0} item={item} product={product} key={index} hideSoldOut={true} />
    }else{
      return null;
    }
  }).filter(node => node !== null);

  const handleCollectionClick = useCallback((handle)=>{
    setFocusedCollection(handle);
    toggleTrayOpen();
  }, [toggleTrayOpen, setFocusedCollection])


  //expirement related code
  useEffect(() => {
    if(trayTrigger == "preopen" && window.innerWidth > 1150){
      //open tray
      toggleTrayOpen(true);
    }
  }, [collection, trayTrigger])

  let showTrayLink;
  switch(trayTrigger){
    case "click":
    case "preopen":
      showTrayLink = true;
  }

  return <>
          {loading || recomendationNodes?.length == 0 ?
            null
          :
            <div className="cart-drawer__line-items">
              <div>
                <span className="flex gap-2">
                  { collection.selectedExperience && focusedCollection == collection.handle ?
                    <div class="cart-drawer__colleciton-indicator"></div>
                  : null }
                  <p class="h6">{collection.customizerTitle?.value || collection.title || window.themeVariables?.strings?.cartEssentials || 'Add Essentials'}</p>
                  { collection.selectedExperience && showTrayLink ? 
                    <a onClick={()=>handleCollectionClick(collection.handle)} className="link">Learn More</a>
                  : null }
                </span>
                {collection.description ? <p>{collection.description}</p> : null }
              </div>
              {recomendationNodes}
            </div>
          }
      </>
}


const filterReferencesByCompatibility = (references, compatibilityKeys) => {
  return references.filter((item) => {
    if( item.variant?.reference?.compatibilityKeys?.value ){
      try{
        const variantCompatibilityKeys = JSON.parse(item.variant.reference.compatibilityKeys.value);
        const compatible = variantCompatibilityKeys.find((key)=>{
          if(compatibilityKeys.indexOf(key) > -1){
            return true;
          }
        });
        return compatible;
      }catch(e){
        console.error(e);
        return true;
      }
    }else{
      return true;
    }
  });
}

const filteredVariantsByVehicleData = (variants, vehicles) => {
  const filteredVehicles = []
  const variantsWithVehicles = variants.map((variant) => {
    const variantWithVehicles = {
      ...variant,
      vehicles: []
    };
    vehicles.forEach((vehicle) => {
      if(vehicle.allProducts.includes(variant.id.toString())){
        variantWithVehicles.vehicles.push(vehicle);
        filteredVehicles.push(vehicle);
      }
    });
    return variantWithVehicles;
  });

  const filteredVariants = variantsWithVehicles.filter((variant) => variant.vehicles.length > 0);

  return {
    filteredVariants,
    filteredVehicles
  };
}